import axios from 'axios'

export default {
  namespaced: true,

  state: {
    token: null,
    user: null
  },

  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },

    SET_USER (state, user) {
      state.user = user
    }
  },

  getters: {
    authenticated (state) {
      return state.token && state.user
    },

    user (state) {
      return state.user
    },

    token (state) {
      return state.token
    }
  },

  actions: {
    async login ({ dispatch }, credentials) {
      let response = await axios.post('auth/login', credentials)

      return dispatch('attempt', response.data.token)
    },

    async refreshToken ({ dispatch}) {
      let response = await axios.post('auth/refresh')

      return dispatch('attempt', response.data.token)
    },

    async attempt ({ commit, state }, token) {
      if (token) {
        commit('SET_TOKEN', token)
      }

      if (!state.token) {
        return
      }

      try {
        let response = await axios.get('auth/me')

        commit('SET_USER', response.data)
      } catch (exception) {
        console.log('Get ME failed.')

        commit('SET_TOKEN', null)
        commit('SET_USER', null)
      }
    },

    sessionExpired({commit}) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
      console.log("SESSION EXPIRED")
    },

    logout ({ commit }) {
      return axios.post('auth/logout').then(() => {
        commit('SET_TOKEN', null)
        commit('SET_USER', null)
      }).catch((e) => {
        if(e.response.status == 401){
          commit('SET_TOKEN', null)
          commit('SET_USER', null)
        }
      })
    }
  }
}
